import {
  FACILITY_TYPES,
  PrintFriendlyTable,
  Radio,
  theme,
} from "@project/common"
import { Flex, Typography } from "antd"
import { ColumnsType } from "antd/es/table"
import dayjs from "dayjs"
import React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import {
  FAILURE_TYPES,
  FULL_DATE_FORMAT,
  YM_FORMAT,
} from "../../../../constants"
import { AssessmentOtherFieldsContent } from "./AssessmentOtherFieldsContent"
const StyledFlex = styled(Flex)`
  #summary__info {
    p,
    span {
      font-size: 8pt;
      .left {
        margin-left: 8px;
      }
    }
  }
  .summary_details {
    display: flex;
    flex-wrap: wrap;
    column-gap: 16px;
    row-gap: 8px;
    .content {
      min-width: 80px;
      width: fit-content;
      border-bottom: 2px solid ${theme.colors?.["text-gray"]};
      .label,
      .value {
        font-size: 8pt;
      }
      .center {
        text-align: center;
      }
    }
  }
  table {
    tbody {
      tr {
        page-break-inside: avoid !important;
      }
    }
  }
`
export const AssessmentDetailPrintContent = React.forwardRef(
  (
    {
      staff_name,
      assessmentData: { assessmentDetail, assessmentSetting },
      extra,
    }: {
      extra?: any
      assessmentData: {
        assessmentDetail: any
        assessmentSetting: any[]
      }
      title: string
      staff_name?: string | null
    },
    ref: any,
  ): JSX.Element => {
    const { t } = useTranslation()

    return (
      <StyledFlex ref={ref} vertical gap={3}>
        <Flex gap={4} justify={"space-between"} id={"summary__info"}>
          <Typography.Text strong> {t("Assessment Sheet")}</Typography.Text>
          <Flex vertical align={"flex-end"}>
            <Typography.Text>
              <span>{t("Facility name")}</span>
              {":"}
              <Typography.Text className={"left"}>
                {assessmentDetail?.user?.active_contract?.facility
                  ?.facility_name || ""}
              </Typography.Text>
            </Typography.Text>
            <Typography.Text>
              <span>
                {t("Use service")} {":"}
              </span>
              <Typography.Text className={"left"}>
                {t(
                  FACILITY_TYPES?.find(
                    (type) =>
                      type?.value ===
                      assessmentDetail?.user?.user_certificate?.service_type,
                  )?.label || "",
                )}
              </Typography.Text>
            </Typography.Text>
            <Typography.Text>
              <span>
                {t("Created date")} {":"}
              </span>
              <Typography.Text className={"left"}>
                {dayjs(assessmentDetail?.creation_date).format(
                  FULL_DATE_FORMAT,
                )}
              </Typography.Text>
            </Typography.Text>
            <Typography.Text>
              <span>
                {t("Creator")} {":"}
              </span>
              <Typography.Text className={"left"}>
                {extra || staff_name || ""}
              </Typography.Text>
            </Typography.Text>
          </Flex>
        </Flex>
        <div className={"summary_details"}>
          <div className={"content"}>
            <div className={"label"}>{t("User name(Furigana)")}</div>
            <div className={"value"}>
              {assessmentDetail?.user?.username}
              {`(${assessmentDetail?.user?.furigana})`}
            </div>
          </div>
          <div className={"content"}>
            <div className={"label"}>{t("Date of birth")}</div>
            <div className={"value"}>
              {dayjs(assessmentDetail?.user?.dob?.split("T")?.[0]).format(
                FULL_DATE_FORMAT,
              )}
            </div>
          </div>
          <div className={"content"}>
            <div className={"label"}>{t("Gender")}</div>
            <div className={"value "}>
              {t(assessmentDetail?.user?.gender || "")}
            </div>
          </div>
          <div className={"content"}>
            <div className={"label"}>{t("Service start date")}</div>
            <div className={"value"}>
              {assessmentDetail?.user?.user_certificate?.start_date
                ? dayjs(
                    assessmentDetail?.user?.user_certificate?.start_date,
                  )?.format(FULL_DATE_FORMAT)
                : ""}
            </div>
          </div>
          <div className={"content"}>
            <div className={"label"}>{t("No of Assessment")}</div>
            <div className={"value center"}>
              {assessmentDetail?.creation_number}
            </div>
          </div>
          <div className={"content"}>
            <div className={"label"}>{t("Recipient certificate number")}</div>
            <div className={"value "}>
              {assessmentDetail?.user?.user_certificate?.number || ""}
            </div>
          </div>
          <div className={"content"}>
            <div className={"label"}>{t("Failure type")}</div>
            <div className={"value"}>
              {FAILURE_TYPES.filter(
                (_, index) =>
                  assessmentDetail?.user?.failure_types?.includes(index),
              )
                .map((d) => t(d))
                .join(", ")}
            </div>
          </div>
        </div>

        {assessmentSetting?.map((setting) => (
          <Flex vertical gap={8} key={setting?.id}>
            {setting?.assessment_category?.map((category) => (
              <>
                {category?.assessment_item?.length > 0 &&
                category?.display_category ? (
                  <>
                    {setting?.title?.toLowerCase() === "work" && (
                      <AssessmentOtherFieldsContent
                        title={t(category?.title || "")}
                        fields={category?.assessment_item
                          ?.filter((v) => v?.display_item)
                          ?.map((item) => ({
                            label: t(item?.title || ""),
                            type:
                              item?.title ===
                              "Disclosure of disability information"
                                ? "checkbox"
                                : undefined,
                            value:
                              item?.title !==
                              "Employment history/training history, etc."
                                ? item?.answer || ""
                                : assessmentDetail?.assessment_employment_item?.map(
                                    (item, index) => ({
                                      title: t(`就労歴・訓練歴等${index + 1}`),
                                      items: [
                                        {
                                          label: t("Start Month"),
                                          value: item?.start_date
                                            ? dayjs(item?.start_date)?.format(
                                                YM_FORMAT,
                                              )
                                            : "---",
                                          type: "date",
                                        },
                                        {
                                          label: t("End Month"),
                                          value: item?.end_date
                                            ? dayjs(item?.end_date)?.format(
                                                YM_FORMAT,
                                              )
                                            : "---",
                                        },
                                        {
                                          label: t(
                                            "Company name/facility name",
                                          ),
                                          value: item?.company_name || "---",
                                        },
                                        {
                                          label: t("Detail"),
                                          value: item?.detail || "---",
                                        },
                                      ],
                                    }),
                                  ),
                          }))}
                      />
                    )}
                  </>
                ) : null}
              </>
            ))}
            {(setting?.title?.toLowerCase() === "support" ||
              setting?.title?.toLowerCase() === "aptitude/skills") && (
              <>
                {setting?.assessment_category?.length > 0 ? (
                  <Flex vertical gap={8}>
                    <div
                      style={{
                        borderBottom: `1px solid ${theme.colors.border}`,
                        paddingBottom: "8px",
                      }}
                    >
                      {t(setting?.title || "")}
                    </div>
                    {setting?.assessment_category?.map((category) =>
                      category?.assessment_item?.length > 0 &&
                      category?.display_category ? (
                        <AssessmentEntityItemTable
                          key={category?.id}
                          categoryTitle={category?.title || ""}
                          assessmentItems={
                            category?.assessment_item?.filter(
                              (v) => v?.display_item,
                            ) || []
                          }
                        />
                      ) : null,
                    )}
                  </Flex>
                ) : (
                  ""
                )}
              </>
            )}
            {/* //for other settings */}
            {setting?.title?.toLowerCase() === "other" && (
              <>
                {setting?.assessment_category?.map((category) => (
                  <>
                    {category?.assessment_item?.length > 0 &&
                    category?.display_category ? (
                      <AssessmentOtherFieldsContent
                        key={category?.id}
                        title={t(category?.title || "")}
                        fields={category?.assessment_item
                          ?.filter((v) => v?.display_item)
                          ?.map((item) => ({
                            label: t(item?.title || ""),
                            value: item?.answer || "",
                          }))}
                      />
                    ) : null}
                  </>
                ))}
              </>
            )}
          </Flex>
        ))}
      </StyledFlex>
    )
  },
)

export const AssessmentEntityItemTable = ({
  categoryTitle,
  assessmentItems,
}: {
  categoryTitle: string
  assessmentItems: any[]
}) => {
  const { t } = useTranslation()
  const columns: ColumnsType<any[]> = [
    {
      key: 1,
      title: t(categoryTitle) || "",
      align: "center",
      width: 140,
      render: (row) => t(row?.title),
    },
    {
      key: 2,
      title: <span style={{ whiteSpace: "nowrap" }}>{t("Can ")}</span>,
      align: "center",
      render: (row: any) => (
        <Radio
          disabled
          type={"radio"}
          checked={row?.answer === "1" ? true : false}
          noLabel
          radioSize={15}
        />
      ),
      className: "fixed_width_75",
    },
    {
      key: 3,
      title: (
        <span style={{ whiteSpace: "nowrap" }}>{t("need a little help")}</span>
      ),
      align: "center",
      className: "fixed_width_75",
      render: (row: any) => (
        <Radio
          disabled
          type={"radio"}
          checked={row?.answer === "2" ? true : false}
          noLabel
          radioSize={15}
        />
      ),
    },
    {
      key: 4,
      title: <span style={{ whiteSpace: "nowrap" }}>{t("need help")}</span>,
      align: "center",
      className: "fixed_width_75",
      render: (row: any) => (
        <Radio
          disabled
          type={"radio"}
          checked={row?.answer === "3" ? true : false}
          noLabel
          radioSize={15}
        />
      ),
    },
    {
      key: 5,
      title: <span style={{ whiteSpace: "nowrap" }}>{t("Can not")}</span>,
      align: "center",
      className: "fixed_width_75",
      render: (row: any) => (
        <Radio
          disabled
          type={"radio"}
          checked={row?.answer === "4" ? true : false}
          noLabel
          radioSize={15}
        />
      ),
    },
    {
      key: 6,
      title: <span style={{ whiteSpace: "nowrap" }}>{t("Remarks")}</span>,
      align: "center",
      width: 400,
      render: (row) => (
        <div style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
          {row?.remarks}
        </div>
      ),
    },
  ]
  return (
    <PrintFriendlyTable
      columns={columns}
      dataSource={assessmentItems || []}
      headerBg={`1px solid ${theme.colors.border}`}
      border={`1px solid ${theme.colors.border}`}
      padding={"0.2rem"}
    />
  )
}
